import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import capitalize from 'utils/capitalize';
import styles from 'assets/jss/material-dashboard-pro-react/components/profileFormStyle.jsx';

const socialMedia = [
  { name: 'instagram', Icon: InstagramIcon },
  { name: 'facebook', Icon: FacebookIcon },
  { name: 'twitter', Icon: TwitterIcon },
];

class Form extends React.Component {
  state = {
    socialAccounts: this.props.user.socialAccounts
  };

  handleChange = (e) => {
    let value = e.target.value.trim();
    if (e.target.id === 'firstName' || e.target.id === 'lastName') {
      value = capitalize(value);
    }
    this.setState({
      [e.target.id]: value,
    });
  };

  handleSocialAccountChange = (e) => {
    let value = e.target.value.trim();
    this.setState({
      socialAccounts: {
        ...this.state.socialAccounts,
        [e.target.id]: value,
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.props.handleSubmit(this.state);
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.formContainer}>
        <form style={{ padding: '20px' }} onSubmit={this.handleSubmit}>
          <GridContainer justify="center">
            <GridItem xs={11}>
              <h5 className={classes.bodyText}>{this.props.user.email}</h5>
              <GridContainer>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="First Name"
                    id="firstName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'text',
                      onChange: this.handleChange,
                      defaultValue: this.props.user.firstName || '',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Last Name"
                    id="lastName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'text',
                      onChange: this.handleChange,
                      defaultValue: this.props.user.lastName || '',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Username"
                    id="displayName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      required: true,
                      type: 'text',
                      onChange: this.handleChange,
                      defaultValue: this.props.user.displayName,
                    }}
                  />
                </GridItem>
                {[
                  socialMedia.map(({ name, Icon }) => (
                      <GridItem key={name} xs={12} sm={6}>
                      <CustomInput
                        labelText={capitalize(name)}
                        id={name}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: 'text',
                          onChange: this.handleSocialAccountChange,
                          defaultValue: this.props.user.socialAccounts[name],
                          endAdornment: (
                            <InputAdornment position='end'>
                              <Icon />
                            </InputAdornment>
                          ),
                        }}
                        />
                        </GridItem>
                  )),
                ]}
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="City"
                    id="city"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'text',
                      onChange: this.handleChange,
                      defaultValue: this.props.user.city,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="State"
                    id="state"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'text',
                      onChange: (event) => this.handleChange(event),
                      defaultValue: this.props.user.state,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12}>
                  <CustomInput
                    labelText="Bio"
                    id="bio"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'text',
                      onChange: (event) => this.handleChange(event),
                      defaultValue: this.props.user.bio,
                    }}
                  />
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <Button
            type="submit"
            color="primary"
            style={{
              marginLeft: '10px',
              marginBottom: '10px',
              borderRadius: '50px',
              fontWeight: '600',
            }}
          >
            Save Changes
          </Button>
        </form>
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Form);
